export const parseCacheControlMaxAge = (cacheControl?: string | null): number => {
  const noCacheMaxAge = 0;
  if (cacheControl?.includes('no-cache')) {
    return noCacheMaxAge;
  }

  const maxAgeMatch = cacheControl?.match(/max-age\s*=\s*(\d+)/i);

  if (maxAgeMatch) {
    const maxAge = parseInt(maxAgeMatch[1], 10) * 1000;
    return maxAge;
  }

  return noCacheMaxAge;
};
